export default __webpack_public_path__ + "static/media/Bank-documentation.766bb139.md";